import React, { useState } from "react";
import { Modal, Button, Radio } from "antd";
import alertLineIcon from "../../../../assets/images/product/specmanager/alert-line.svg";
import closeLineIcon from "../../../../assets/images/product/specmanager/close-line.svg";
import arrowRightLineIcon from "../../../../assets/images/product/specmanager/arrow-right-line.svg";
import informationIcon from "../../../../assets/images/product/specmanager/information-line.svg";
import "./ProductSpecificSpecsModal.css";

const MIXED_BULLETS = [
  "Some of the selected products have product-specific limits defined.",
  "Updating the spec will apply the new value to products following the standard spec.",
  "Products with product-specific specs will remain unchanged unless you choose to override them.",
];

export default function ProductSpecificSpecsModal({
  open,
  variant,
  customProductsCount,
  loading,
  onCancel,
  onApplyStandardOnly,
  onApplyAllSelected,
  onSaveAllStandard,
}) {
  const [mixedChoice, setMixedChoice] = useState("standard");

  const title = variant === "customOnly" ? "Confirm Spec Update" : "Products with Custom Specs";
  const applyHandler = mixedChoice === "standard" ? onApplyStandardOnly : onApplyAllSelected;

  const handleConfirm = () => {
    if (variant === "mixed") {
      applyHandler();
      return;
    }
    if (variant === "customOnly") {
      onApplyAllSelected();
      return;
    }
    onSaveAllStandard();
  };

  const applyLabel = (variant === "standardOnly" || (variant === "mixed" && mixedChoice === "standard"))
    ? "Apply"
    : "Apply to All";

  return (
    <Modal
      open={open}
      closable={false}
      footer={null}
      centered
      destroyOnClose
      width={560}
      wrapClassName="ProductSpecificSpecsModal_Wrap"
      onCancel={onCancel}
    >
      <div className="ProductSpecificSpecsModal">
        <div className="ProductSpecificSpecsModal_Header">
          {variant === "mixed" && (
            <img src={alertLineIcon} alt="" className="ProductSpecificSpecsModal_HeaderIcon" aria-hidden />
          )}
          <div className="ProductSpecificSpecsModal_HeaderTitle">{title}</div>
          <button
            type="button"
            className="ProductSpecificSpecsModal_CloseBtn"
            disabled={loading}
            aria-label="Close"
            onClick={onCancel}
          >
            <img src={closeLineIcon} alt="" className="ProductSpecificSpecsModal_CloseIcon" aria-hidden />
          </button>
        </div>

        <div className="ProductSpecificSpecsModal_Body">
          {variant === "mixed" && (
            <>
              <ul className="ProductSpecificSpecsModal_Bullets">
                {MIXED_BULLETS.map((text) => (
                  <li key={text}>{text}</li>
                ))}
              </ul>
              <Radio.Group
                value={mixedChoice}
                onChange={(event) => setMixedChoice(event.target.value)}
                className="ProductSpecificSpecsModal_RadioGroup"
              >
                <Radio value="standard">Apply to standard spec products only</Radio>
                <Radio value="all">Apply to all selected products</Radio>
              </Radio.Group>
            </>
          )}
          {variant === "standardOnly" && (
            <p className="ProductSpecificSpecsModal_Lead">
              Updating the spec will apply the new value to all selected products following the standard spec.
            </p>
          )}
          {variant === "customOnly" && (
            <p className="ProductSpecificSpecsModal_Lead">
              All selected products have custom limits. The update will apply to all selected products.
            </p>
          )}
        </div>

        {customProductsCount > 0 && (
          <div className="ProductSpecificSpecsModal_Banner">
            <img src={informationIcon} alt="" className="ProductSpecificSpecsModal_BannerIcon" aria-hidden />
            <span>
              <strong>{customProductsCount}</strong>
              {" "}
              product(s) have product-specific spec.
            </span>
          </div>
        )}

        <div className="ProductSpecificSpecsModal_Footer">
          <Button onClick={onCancel} disabled={loading}>Cancel</Button>
          <Button
            type="primary"
            loading={loading}
            onClick={handleConfirm}
          >
            <span className="ProductSpecificSpecsModal_ApplyLabel">
              {applyLabel}
              <img src={arrowRightLineIcon} alt="" className="ProductSpecificSpecsModal_ApplyArrow" aria-hidden />
            </span>
          </Button>
        </div>
      </div>
    </Modal>
  );
}
